<template>
  <div
    class="futuro-loader"
    :class="{ 'futuro-loader--block': block }"
    role="status"
    aria-live="polite"
  >
    <img
      :src="marca"
      :width="size"
      :height="size"
      alt=""
      aria-hidden="true"
      class="futuro-loader__marca"
    />
    <span v-if="showLabel" class="futuro-loader__label">{{ label }}</span>
    <span v-else class="sr-only">{{ label }}</span>
  </div>
</template>

<script>
/**
 * Loader da marca: o logo da Futuro se desenhando.
 *
 * A animação NÃO está aqui — ela vive dentro do próprio SVG, em CSS
 * (src/assets/images/logo/futuro-outline.svg, gerado por
 * scripts/build-logo-outline.js). Isso é de propósito: o mesmo arquivo serve
 * como <img> em qualquer contexto, inclusive no loader de public/index.html,
 * que roda antes de o Vue existir. Duplicar os paths num componente Vue criaria
 * duas cópias da geometria do logo para divergirem com o tempo.
 *
 * O SVG traz o próprio guard de prefers-reduced-motion: com movimento reduzido
 * ele mostra o logo completo, parado, em vez de nada.
 *
 * Quando usar: espera com peso, em que a marca cabe — carga inicial de tela,
 * troca de competência no Faturômetro, um relatório sendo montado. Para espera
 * curta dentro de um botão, o b-spinner que o app já usa continua sendo o certo;
 * um logo de 96px piscando num botão é ruído, não polimento.
 */
export default {
  name: 'FuturoLoader',
  props: {
    /** Lado do quadrado, em px. O traço escala junto por ser vetor. */
    size: {
      type: [Number, String],
      default: 96,
    },
    /** Lido por leitor de tela sempre; visível só com show-label. */
    label: {
      type: String,
      default: 'Carregando...',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    /** Ocupa a largura toda e centraliza — para estado de carga de uma seção. */
    block: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    marca() {
      // eslint-disable-next-line global-require
      return require('@/assets/images/logo/futuro-outline.svg')
    },
  },
}
</script>

<style lang="scss" scoped>
.futuro-loader {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;

  &--block {
    display: flex;
    width: 100%;
    padding: 2.5rem 0;
  }
}

.futuro-loader__marca {
  display: block;
}

.futuro-loader__label {
  font-size: 0.857rem;
  color: #b9b9c3;
  letter-spacing: 0.01em;
}
</style>
